<!--
 * @title: 养护方案
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/6/1 17:35
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <d2-container>
        <div v-show="!dialogShow">
        <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form
            popoverWidth="680"
            :formConfig="searchConfig"
            v-model="search"
            @onSubmit="onSearch"></popover-form>
        </el-col>
        <el-col :span="20">
          <div class="text-align_right">
           <el-button type="primary" v-if="verifyAuthority('system.gsims.ConservationProgram.downLoad')"
             @click="fileDownload($url.assessExport.exportRoadDecisionReport,{exportData,...search})">导出</el-button>
          </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="paging.page"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="onPagingSizeChange"
          :pageCount="paging.total"
          @rowClick="onLook()"
          @onSelection="selection($event)">
        </dynamic-table>
      </div>
      </div>
        <!-- <page-body v-show="!dialogShow"
                   :page-size="paging.limit"
                   :total="paging.total"
                   :current-page="paging.page"

                   @size-change="onPagingSizeChange"
                   @current-change="onPagingCurrentLimitChange">
            <template v-slot:default>
                <page-table
                        ref="page_table"
                        :buttons="buttons"
                        :table-column-attributes="pageConfig.tableColumnAttributes"
                        :value="tableData"
                        :toolbar-buttons="toolbarButtons"
                        :loading="loading"
                        :showCheckbox="true"
                        @search-click="onSearch"
                        @add-click="onAdd"
                        @look-click="onLook"
                        @update-click="onUpdate"
                        @delete-click="onDelete"
                        @selection-change="selectionChange"
						@onSelection="selection($event)"
                        :handle-column="true"
                >
                    <template v-slot:advanced-search>
                        <popover-form :form-config="searchConfig" v-model="search" @onSubmit="onSearch"></popover-form>
                    </template>
                </page-table>
            </template>
        </page-body> -->
        <page-edit-layout v-model="dialogValue" v-show="dialogShow">
            <template v-slot:button>
                <div class="common-flex-center-end">
                    <el-button type="primary" @click="dialogShow = false">返回</el-button>
                </div>
            </template>
            <template v-slot>
                <divider title="基础数据"></divider>
                <dynamic-form ref="dialogValue" :disabled="true" :form-config="dialogFormConfig" v-model="dialogValue"></dynamic-form>
                <divider title="明细信息"></divider>
                <div style="height: 25%;">
                    <page-table
                            :buttons="buttons"
                            :table-column-attributes="pageConfig.detailsTableColumnAttributes"
                            :value="pageConfig.detailsTableData"
                            :show-table-toolbar="false"
                            :loading="loading"
                            :handle-column="false"
                    >
                    </page-table>
                </div>
                <!-- <divider title="图示"></divider>
                <div style="height: 420px;" v-if="dialogShow">
                    <ve-pie :data="pageConfig.chartData"></ve-pie>
                </div> -->
            </template>
        </page-edit-layout>
        
        <!-- <div style="display: inline-block;text-align: right;position: absolute;top: 29px;right: 20px;">
            <el-button type="primary" v-show="!dialogShow" v-if="verifyAuthority('system.gsims.ConservationProgram.downLoad')"
            @click="daochu">导出</el-button>
        </div> -->
    </d2-container>
</template>

<script>
	import { Message} from 'element-ui'
    import PageBody from "@/components/Pages/PageBody";
    import PageTable from "@/components/Pages/PageTable/index";
    import PageEditLayout from "@/components/Pages/layout/PageEditLayout";
    export default {
        name: "index",
        components: {PageTable, PageBody, PageEditLayout},
        data() {
            return {
                //分页
                paging: {},
                //搜索数据
                search: {routeCode:"",routeName:'',planningName:""},
				//导出数据
				exportData: {},
                //表格数据
                tableData: [],
                //页面配置
                tableSet:{
                    tableColumn: [
                        {label: '规划名称', prop: 'planningName'},
                        // {label: '规划类型', prop: 'planningType', type: 'String', width: 'auto', children: [],options: [
                        //     { label: "单年度规划", value: "1" }, { label: "多年度规划", value: "2" }
                        // ]},
                        {label: '路线名称', prop: 'routeName'},
                        {label: '路线编码', prop: 'routeCode'},
                        {label: '分析年度', prop: 'annual'},
                        {label: '年度养护费用(万元)', prop: 'annualMaintenanceCost'},
                        {label: '年度日常养护费用(万元)', prop: 'annualDailyMaintenanceCost',type: 'StriannualDailyMaintenanceCostng',},
                        {label: '年度预防性养护费用(万元)', prop: 'annualPreventiveMaintenanceCost'},
                        {label: '年度预功能性修复费用(万元)', prop: 'annualRepairCost'},
                        {label: '年度预结构性修复费用(万元)', prop: 'annualOverhaulMaintenanceCost'},
                    ],
                    tableColBtn: [
                        {
                        show: true,
                        size: 'mini ',
                        type: 'primary',
                        plain: true,
                        round: false,
                        circle: false,
                        loading: false,
                        disabled: false,
                        icon: 'el-icon-view',
                        title: '查看',
                        name: '查看',
                        click: this.onLook
                        },
                    ]
                },
                pageConfig: {
                    // 表格列属性
                    // tableColumnAttributes: [
                    //     {label: '规划名称', prop: 'planningName'},
                    //     // {label: '规划类型', prop: 'planningType', type: 'String', width: 'auto', children: [],options: [
                    //     //     { label: "单年度规划", value: "1" }, { label: "多年度规划", value: "2" }
                    //     // ]},
                    //     {label: '路线名称', prop: 'routeName'},
                    //     {label: '路线编码', prop: 'routeCode'},
                    //     {label: '分析年度', prop: 'annual'},
                    //     {label: '年度养护费用(万元)', prop: 'annualMaintenanceCost'},
                    //     {label: '年度日常养护费用(万元)', prop: 'annualDailyMaintenanceCost',type: 'StriannualDailyMaintenanceCostng',},
                    //     {label: '年度预防性养护费用(万元)', prop: 'annualPreventiveMaintenanceCost'},
                    //     {label: '年度预功能性修复费用(万元)', prop: 'annualRepairCost'},
                    //     {label: '年度预结构性修复费用(万元)', prop: 'annualOverhaulMaintenanceCost'},
                    // ],
                    // 明细表
                    detailsTableColumnAttributes: [
                        {label: '行车方向', prop: 'drivingDirection', type: 'String', width: 'auto', children: []},
                        {label: '起点桩号', prop: 'startStake', type: 'Stake', width: 'auto', children: []},
                        {label: '止点桩号', prop: 'endStake', type: 'Stake', width: 'auto', children: []},
                        {label: '养护类型', prop: 'curingType', type: 'String', width: 'auto', children: []},
                        {label: '养护措施', prop: 'preventiveMaintenanceMeasures', type: 'String', width: 'auto', children: []},
                        {label: '养护年限', prop: 'preventiveMaintenanceLife', type: 'String', width: 'auto', children: []},
                        {label: '养护费用(万元)', prop: 'maintenanceCosts', type: 'String', width: 'auto', children: []},
                    ],
                    detailsTableData: [],
                    chartData: {
                        columns: ['日期', '访问用户'],
                        rows: [
                            {'日期': '1/1', '访问用户': 1393},
                            {'日期': '1/2', '访问用户': 3530},
                            {'日期': '1/3', '访问用户': 2923},
                            {'日期': '1/4', '访问用户': 1723},
                            {'日期': '1/5', '访问用户': 3792},
                            {'日期': '1/6', '访问用户': 4593}
                        ]
                    }
                },
                // 工具栏按钮
                toolbarButtons: 0,
                // 表格加载
                loading: false,
                // 查看模式
                lookModel: false,
                // 弹出层数据
                dialogValue: {
                    planningName:"",//规划名称
                    planningType:"",//规划类型
                    routeName:"",//路线名称/路网名称
                    routeCode:"",//路线编码/路网编码
                    annual:"",//分析年度
                    annualMaintenanceCost:"",//年度养护费用（万元）
                    annualDailyMaintenanceCost:"",//年度日常养护费用（万元）
                    annualPreventiveMaintenanceCost:"",//年度预防性养护费用（万元）
                    annualRepairCost:"",//年度中修护费用
                    annualOverhaulMaintenanceCost:"",//年度大修养护费用
                    sublist:[],//
                },
                dialogChildValue:{
                    drivingDirection:"",//行车方向
                    startStake:"",//起点桩号
                    endStake:"",//终点桩号
                    curingType:"",//养护类型
                    preventiveMaintenanceMeasures:"",//养护措施
                    preventiveMaintenanceLife:"",//养护年限
                    maintenanceCosts:"",//养护费用(万元)
                },
                //搜索框配置
                searchConfig: {
                    "list": [
                        {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请输入规划名称",
                            "disabled": false,
                            "remoteFunc": "func_1590921615000_8607"
                        },
                        "name": "规划名称",
                        "key": "planningName",
                        "model": "planningName",
                        "rules": [{"type": "string", "message": "规划名称格式不正确"}]
                        },
                        {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "请输入路线编码",
                            "disabled": false,
                            "remoteFunc": "func_1590921615000_8607"
                        },
                        "name": "路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "路线编码格式不正确"}]
                        },
                    ], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small", "customClass": ""}
                },
                // 弹出层表单配置
                dialogFormConfig: {
                    "list": [{
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "规划批次名称",
                        "key": "planningName",
                        "model": "planningName",
                        "rules": [{"type": "string", "message": "规划批次名称格式不正确"}]
                    }, 
                    {
                        type: "select",
                        icon: "icon-select",
                        options: {
                            defaultValue: "",
                            multiple: false,
                            disabled: true,
                            clearable: false,
                            required: false,
                            showLabel: false,
                            width: "",
                            options: [ { label: "单年度规划", value: "1" }, { label: "多年度规划", value: "2" }, ],
                            remote: false,
                            filterable: false,
                            remoteOptions: [],
                            props: { value: "value", label: "label" },
                            customClass: "",
                            labelWidth: 100,
                            isLabelWidth: false,
                            hidden: false,
                            dataBind: true
                        },
                        name: "规划类型",
                        novalid: {},
                        key: "1575375705656",
                        model: "planningType",
                        rules: []
                    },
                    {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "规划路线编码",
                        "key": "routeCode",
                        "model": "routeCode",
                        "rules": [{"type": "string", "message": "规划路线编码格式不正确"}]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "规划路线名称",
                        "key": "routeName",
                        "model": "routeName",
                        "rules": [{"type": "string", "message": "规划路线名称格式不正确"}]
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "分析年度",
                        "key": "annual",
                        "model": "annual",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "年度养护费用(万元)",
                        "key": "annualMaintenanceCost",
                        "model": "annualMaintenanceCost",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "年度日常养护费用(万元)",
                        "key": "annualDailyMaintenanceCost",
                        "model": "annualDailyMaintenanceCost",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "年度预防性养护费用(万元)",
                        "key": "annualPreventiveMaintenanceCost",
                        "model": "annualPreventiveMaintenanceCost",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "年度功能性修复费用(万元)",
                        "key": "annualRepairCost",
                        "model": "annualRepairCost",
                        "rules": []
                    }, {
                        "type": "input",
                        "icon": "icon-input",
                        "options": {
                            "width": "100%",
                            "defaultValue": "",
                            "required": false,
                            "dataType": "string",
                            "pattern": "",
                            "placeholder": "",
                            "disabled": true,
                            "remoteFunc": "func_1591004468000_30974"
                        },
                        "name": "年度结构性修复费用(万元)",
                        "key": "annualOverhaulMaintenanceCost",
                        "model": "annualOverhaulMaintenanceCost",
                        "rules": []
                    }], "config": {"labelWidth": 100, "labelPosition": "right", "size": "small"}
                },
                // 弹出层控制属性
                dialogShow: false
            }
        },
        methods: {
            daochu(){
                console.log(this.exportData);
				this.fileDownload(this.$url.assessExport.exportRoadDecisionReport,{exportData:this.exportData,...this.search})
            },
			//勾选
			selection(val) {
                console.log(val);
			  let data = new Array();
			  if (val) {
			    for (let item of val) {
			      data.push(item.rowCode);
			    }
			  }
			  this.exportData = {rowCode: data.toString() };
			},
            selectionChange(val){
                console.log(val)
				let data = new Array();
				if (val) {
				  for (let item of val) {
				    data.push(item.rowCode);
				  }
				}
				this.exportData = { rowCode: data.toString() };
            },
			
            //分页大小变更事件
            onPagingSizeChange(size) {
                this.paging.setSize(size)
                this.refreshData(this.paging, this.search)
            },
            // 分页当前页变动事件
            onPagingCurrentLimitChange(current) {
                this.paging.setIndex(current)
                this.refreshData(this.paging, this.search)
            },
            // 搜索事件
            onSearch() {
                this.refreshData(this.paging, this.search);
            },
            // 新增
            onAdd() {
            },
            // 查看
            onLook(row) {
                this.$http.post(this.$url.routeDecision.getmaintenanceplans,{rowCode:row.rowCode}).then(res=>{
                    this.dialogShow = true;
                    this.dialogValue=res.data[0];
                    if(res.data[0].sublist){
                        this.pageConfig.detailsTableData=res.data[0].sublist;
                    }else{
                        this.pageConfig.detailsTableData=[];
                    }
                })
            },
            // 修改
            onUpdate() {

            },
            // 删除
            onDelete() {

            },
            initial() {
                this.refreshData(this.paging)
            },
            // 刷新数据
            refreshData(paging, search, callback) {
                const searchData = this.Tools.get().ObjectTools.merge(paging, search),
                    url = this.$url.routeDecision.getmaintenanceplans
                // 由于web storm模板影响 请自行配置以下代码
                this.loading = true
                this.$http.post(url, searchData).then(res=>{
                    this.tableData=res.data;
                    this.paging.total = res.pageCount;
                    this.loading = false
                }).catch(error=>{
                    this.loading = false
                })
            },
        },
        computed: {
            // 表格按钮
            buttons() {
                return this.ButtonEnums.TableButtons.descriptionButton 
            }
        },
        mounted() {
            this.paging = this.Paging.default()
            this.initial()
        }
    }
</script>

<style scoped lang="scss">

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningScheme/ConservationProgram/index.vue"
}
</vue-filename-injector>
